import { scrollmagic } from './modules/scrollmagic';
import { bnr } from './modules/bnr';

window.addEventListener('load', () => {
  //crollに応じてアニメーションしたい時
  scrollmagic();
  
  //crollによる処理を間引きしたい時
  // scrollAction();
});

bnr();
